// Which runs the dashboard puts in front of you, as pure functions of the run list.
import type { Run } from "../api/client";
import { ACTIVE_RUN } from "../ui/tones";
import { messages } from "../i18n";

const FAILED = new Set(["failed", "timed_out"]);

const rank = (r: Run) => (r.status === "waiting_for_human" ? 0 : ACTIVE_RUN.has(r.status) ? 1 : FAILED.has(r.status) ? 2 : 3);

/** Waiting for you, then live, then failed, then the latest others; newest first in each. */
export function runsNeedingAttention(runs: Run[], limit = 5): Run[] {
  return [...runs].sort((a, b) => rank(a) - rank(b) || b.queued_at - a.queued_at).slice(0, limit);
}

export interface RunCounts {
  working: number;
  waiting: number;
}

export function countRuns(runs: Run[]): RunCounts {
  const waiting = runs.filter((r) => r.status === "waiting_for_human").length;
  const live = runs.filter((r) => ACTIVE_RUN.has(r.status)).length;
  return { working: live - waiting, waiting };
}

/** The page's subtitle: what the agents are doing in a sentence. */
export function summary({ working, waiting }: RunCounts): string {
  const t = messages().dashboard;
  const agents = working + waiting;
  if (agents === 0) return t.noAgents;
  const first = t.working(agents);
  return waiting === 0 ? first : `${first} ${t.paused(waiting)}`;
}
